import { experimentalSearchSchema } from '@/features/agentic-insights/components/experimental/briefing-4/data/searchState';

/**
 * The one place naming which variant is "the default". `VariantPicker`'s `VARIANTS` marks the
 * matching entry `isDefault` from this same id, `experimental/index.tsx` redirects to
 * `DEFAULT_VARIANT_PATH`, and the nav item's bare route renders `DefaultVariantView`
 * (`defaultVariant.tsx`) directly (no redirect — the bare URL has to stay `/agentic-insights`, never
 * `/experimental/...`) — several consumers, one constant, so a later default change is a one-line
 * edit here rather than a hunt across unrelated route files.
 *
 * Deliberately its own module, importing nothing beyond a search schema: `VariantPicker.tsx` reads
 * `DEFAULT_VARIANT_ID` at module-top-level (to compute each row's `isDefault`), and it is itself
 * imported by `RunsCog.tsx`, which `ExperimentalInsightsPage.tsx` (briefing-4) imports. Defining the
 * constant alongside `DefaultVariantView` — which needs `ExperimentalInsightsPage` — would close that
 * into a real import cycle: `VariantPicker` would need a value from a module that (transitively)
 * needs `VariantPicker` itself, and whichever side the bundler evaluates first would read the
 * constant before its own module finished initializing.
 */
export const DEFAULT_VARIANT_ID = 'briefing-4' as const;

export const DEFAULT_VARIANT_PATH =
  '/org/$org/loop/$loopId/agentic-insights/experimental/briefing-4' as const;

export const defaultVariantSearchSchema = experimentalSearchSchema;
